import HttpRequest from './HttpRequest';

export default class AdomiCategoryService extends HttpRequest {
  static endpoint = 'adomi-categories';

  static async getAll() {
    this.endpoint = 'adomi-categories';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'adomi-categories';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'adomi-categories';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'adomi-categories';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'adomi-categories';
    const response = await this.delete(id);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'adomi-categories/create-image';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'adomi-categories/delete-image';
    const response = await this.delete(data);
    return response;
  }
}
